/**
 * tg-salon-hours.js — Salon open/closed status badge + today row highlight
 *
 * Reads data-hours JSON from #tg-salon-status:
 *   { "monday": "09:00-18:00", "tuesday": "closed", ... }
 *
 * - Sets badge text ("Open now" / "Closed") and CSS class
 * - Adds class tg-today to the <tr data-day="..."> matching today
 */
(function () {
  'use strict';

  var DAY_NAMES = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  function toMins(hhmm) {
    var parts = (hhmm || '').split(':');
    if (parts.length !== 2) return NaN;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    return isNaN(h) || isNaN(m) ? NaN : h * 60 + m;
  }

  function isOpenNow(hoursStr, nowMins) {
    if (!hoursStr || hoursStr === 'closed') return false;
    var sep = hoursStr.indexOf('-');
    if (sep === -1) return false;
    var openMins  = toMins(hoursStr.slice(0, sep));
    var closeMins = toMins(hoursStr.slice(sep + 1));
    if (isNaN(openMins) || isNaN(closeMins)) return false;
    return nowMins >= openMins && nowMins < closeMins;
  }

  function init() {
    var badge = document.getElementById('tg-salon-status');
    if (!badge) return;

    var hoursData;
    try {
      hoursData = JSON.parse(badge.getAttribute('data-hours') || '{}');
    } catch (e) {
      return;
    }

    var now      = new Date();
    var todayKey = DAY_NAMES[now.getDay()];
    var nowMins  = now.getHours() * 60 + now.getMinutes();

    var todayRow = document.querySelector('[data-day="' + todayKey + '"]');
    if (todayRow) todayRow.classList.add('tg-today');

    var open = isOpenNow(hoursData[todayKey], nowMins);
    badge.textContent = open ? 'Open now' : 'Closed';
    badge.className   = open ? 'tg-sh__status tg-sh__status--open'
                             : 'tg-sh__status tg-sh__status--closed';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
